(function () {
  var CACHE_KEY = 'shipping_region';
  var CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

  var STATE_ABBR = {
    'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR',
    'California': 'CA', 'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE',
    'Florida': 'FL', 'Georgia': 'GA', 'Hawaii': 'HI', 'Idaho': 'ID',
    'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
    'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
    'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS',
    'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV',
    'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY',
    'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK',
    'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
    'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT',
    'Vermont': 'VT', 'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV',
    'Wisconsin': 'WI', 'Wyoming': 'WY', 'District of Columbia': 'DC'
  };

  function toStateCode(region) {
    if (!region) return null;
    var trimmed = region.trim();
    if (trimmed.length === 2) return trimmed.toUpperCase();
    return STATE_ABBR[trimmed] || null;
  }

  function getCache() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY));
      if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
        return cached;
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function registerStore(region, loading) {
    if (window.Alpine) {
      try {
        var existing = Alpine.store('shipping');
        if (existing) {
          existing.region = region;
          existing.loading = loading;
          return;
        }
      } catch (e) { /* store doesn't exist yet */ }
      Alpine.store('shipping', {
        region: region,
        loading: loading
      });
    }
  }

  var cached = getCache();

  // Register store when Alpine initializes (if we get there first)
  document.addEventListener('alpine:init', function () {
    Alpine.store('shipping', {
      region: cached ? cached.code : null,
      loading: !cached
    });
  });

  // Also register if Alpine already initialized (if we loaded late)
  if (window.Alpine) {
    registerStore(cached ? cached.code : null, !cached);
  }

  if (!cached) {
    fetch('https://get.geojs.io/v1/ip/geo.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.country_code === 'US' && data.region) {
          var code = toStateCode(data.region);
          if (code) {
            var cacheData = { code: code, timestamp: Date.now() };
            try { localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData)); } catch (e) { /* ignore */ }
            registerStore(code, false);
            return;
          }
        }
        registerStore(null, false);
      })
      .catch(function () {
        registerStore(null, false);
      });
  }
})();
